var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view',[_vm._v(" NOTHING TO SEE HERE FEFE.. THIS IS JUST A WRAPPER FOR THE DYNAMIC ROUTES.. ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }